<template>
    <div class="p-fluid bg-white p-3 borda-card-personalizada" style="border-radius: 0.125rem; min-height: 21rem !important">
        <erros-box :erros="erros"></erros-box>
        <div class="flex flex-row align-items-center justify-content-between">
            <h6 class="lato-bolder" style="font-size: 1rem">
                Aprovado por <span style="color: #3e6ba8">{{ acoes?.filter((a) => a?.descricao === 1).length }} de 3</span>
            </h6>
        </div>

        <div>
            <p class="mb-0 lato-bolder" style="font-size: 0.938rem; color: #282a31">Diretores</p>
            <div class="flex flex-column">
                <div v-for="acao in this.acaoDiretores" v-bind:key="acao?.acaoId" class="flex flex-row align-items-center" style="margin-top: 1rem">
                    <Avatar
                        style="background-color: #c2f3ff; color: #111a27"
                        :label="formataIniciaisNomeAvatar(acao?.aprovadorNome)"
                        class="mr-2 mb-1 lato-bolder"
                        size="large"
                        shape="circle"
                    />

                    <p class="lato-bolder" style="font-size: 1rem">
                        {{ acao?.aprovadorNome }}
                        <i v-if="acao?.descricao === 0" class="pi pi-times" @click="dataFim = null" style="color: red; font-size: 14px"></i>

                        <i
                            v-if="acao?.descricao === 1 && acao?.tipoAcao === 0"
                            class="pi pi-check cursor-pointer"
                            @click="dataFim = null"
                            style="color: #3e6ba8 !important; font-size: 14px"
                        ></i>

                        <font-awesome-icon
                            v-if="acao?.descricao === 1 && acao?.tipoAcao === 1"
                            icon="check-double"
                            class="text-xs ml-2 mt-2"
                            style="color: #3e6ba8 !important"
                        />
                    </p>
                </div>

                <div v-if="acaoDiretores?.length <= 0" class="flex flex-row align-items-center" style="margin-top: 1rem">
                    <p class="lato-medium" style="color: #666666">Nenhum diretor aprovou ainda</p>
                </div>
            </div>
        </div>

        <div style="margin-top: 1.5rem">
            <p class="mb-0 lato-bolder" style="font-size: 0.938rem; color: #282a31">Gerente Financeiro</p>

            <div v-for="acao in acaoGerentes" v-bind:key="acao?.acaoId" class="flex flex-row align-items-center" style="margin-top: 1rem">
                <Avatar
                    style="background-color: #c2f3ff; color: #111a27"
                    :label="formataIniciaisNomeAvatar(acao?.aprovadorNome)"
                    class="mr-2 mb-1 lato-bolder"
                    size="large"
                    shape="circle"
                />

                <p class="lato-bolder" style="font-size: 1rem">
                    {{ acao?.aprovadorNome }}
                    <i v-if="acao?.descricao === 0" class="pi pi-times cursor-pointer" @click="dataFim = null" style="color: red; font-size: 14px"></i>

                    <i
                        v-if="acao?.descricao === 1 && acao?.tipoAcao === 0"
                        class="pi pi-check cursor-pointer"
                        @click="dataFim = null"
                        style="color: #3e6ba8 !important; font-size: 14px"
                    ></i>

                    <font-awesome-icon
                        v-if="acao?.descricao === 1 && acao?.tipoAcao === 1"
                        icon="check-double"
                        class="text-xs ml-2 mt-2"
                        style="color: #3e6ba8 !important"
                    />
                </p>
            </div>

            <div v-if="acaoGerentes?.length <= 0" class="flex flex-row align-items-center" style="margin-top: 1rem">
                <p class="lato-medium" style="color: #666666">Nenhum gerente aprovou ainda</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        acoes: {
            type: Array,
        },
    },

    methods: {
        formataIniciaisNomeAvatar(nome = '') {
            const splitNome = nome.split(' ');
            const primeiraLetra = splitNome[0].split('')[0];
            const segundaLetra = splitNome[1].split('')[0];

            return `${primeiraLetra}${segundaLetra}`;
        },
    },

    computed: {
        acaoDiretores() {
            return this.acoes?.filter((a) => a.cargo === 1);
        },

        acaoGerentes() {
            return this.acoes?.filter((a) => a.cargo === 0);
        },
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

.lato-bolder {
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 700;
}

.lato-medium {
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 500;
}

.borda-card-personalizada {
    border: 1px solid #e0e3e7;
    font-size: 0.875rem;
}
</style>
